import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { AppSvgIconComponent, OverlayService } from '@vallift/ngl';
import {
  VariablePickerOverlayComponent,
  type VariablePickerResult,
  type VariablePickerValueType,
} from '../variable-picker-overlay/variable-picker-overlay';

@Component({
  selector: 'app-link-variable-button',
  standalone: true,
  imports: [AppSvgIconComponent],
  templateUrl: './link-variable-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkVariableButtonComponent {
  private readonly overlayService = inject(OverlayService);

  readonly valueTypes = input.required<VariablePickerValueType[]>();
  readonly label = input('Link variable');
  readonly variableSelected = output<VariablePickerResult>();

  openPicker(): void {
    const valueTypes = this.valueTypes();
    if (valueTypes.length === 0) {
      return;
    }
    const dialogRef = this.overlayService.openModal(
      VariablePickerOverlayComponent,
      { data: { valueTypes } },
    );
    dialogRef.closed.subscribe(
      (result: VariablePickerResult | null | undefined) => {
        if (!result) {
          return;
        }
        this.variableSelected.emit(result);
      },
    );
  }
}
